module.exports = __webpack_public_path__ + "img/leftimage.3daadab5.svg";